
































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import upload from "@/components/upload/src/index.vue";
import {getConfig, getDetailByUrl, getDetailById, saveEditItemDetail, copyItem, checkDuplicate} from '@/services/api'
import store from "@/store";
import validator from "@/services/validatorNew";
import draggable from 'vuedraggable'

@Component({
  components: {
    'zf-upload': upload,
    draggable
  },
})
export default class EditModify extends Vue{
  // 页面类型: ADD: 新建; MODIFY: 修改; COPY: 复制; PARSE: 解析(新建解析成功后)
  public ADD = 'add';
  public MODIFY = 'modify';
  public COPY = 'copy';
  public PARSE = 'parse';
  public DISABLED = 255;
  // 解析状态
  public parsed = false;

  // 当前的tab
  public activeName = 'info';

  public materialCdnBaseUrl = 'https://geovn0mhn4u98k.josyliving.com/Public/';
  public asset!: {Video:{VideoPreviewImageURL:string,VideoSdURL:string}, Images: {OriginalImageURL:string}[]};
  // 地区列表
  public countryList: {code: string, name: string}[] = [];
  // 语言列表
  public languageList: string[] = [];

  // 上传表单
  public formData: any = {
    mainInfo: {},
    spus: [],
    goods: [],
    covers: [],
    details: [],
    editCode: 0
  };

  public tspuIdList: string[] = [];

  // 新建spuId
  newSpuId = 10;

  // 验证规则
  private rules: {[key: string]:{required: boolean, requiredMsg?: string, reg?: RegExp, regMsg?: string, max?: number, maxMsg?: string, min?: number, minMsg?: string}}= {
    country: {required: true, requiredMsg: '投放地区不能为空'},
    language: {required: true, requiredMsg: '投放语言不能为空'},
    title: {required: true, requiredMsg: '落地页title不能为空'},
    price: {required: true, requiredMsg: '价格不能为空'}
  }

  // 上传图片地址
  public uploadUrl = (process.env.VUE_APP_BASE_API.length == 0 ? (location.origin + "/") : process.env.VUE_APP_BASE_API) + 'api/item_create/uploadImages';
  // 轮播图回显列表
  public coverShowList: {url: string, name: string}[] = [];
  // 轮播图上传列表
  public coverList: {url: string, name: string}[] = [];
  // 轮播图拖拽排序控制
  public coverDraggable = false;
  // 详情图回显列表
  public detailShowList: {url: string, name: string}[] = [];
  // 详情图上传列表
  public detailList: {url: string, name: string}[] = [];
  // 详情图拖拽排序控制
  public detailDraggable = false;
  // 大图展示控制
  public dialogVisible = false;
  // 大图展示路径
  public dialogImageUrl = '';
  //是否转寄item
  public isForward = false;
  // 图片查重结果
  public duplicateImages: string[] = [];
  public duplicateImagesVisible: boolean = false;

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    const id = this.$route.params.id;
    this.initForm();

    if (this.scene === this.ADD || this.scene === this.PARSE) {
      this.activeName = 'url';
    } else if (this.scene === this.MODIFY) {
      await this.getDetailById(parseInt(id));
    } else if (this.scene === this.COPY) {
      const country = this.$route.params.country;
      await this.copyItem({copyItemId:parseInt(id), country})
      this.formData.itemId = null;
    }
    this.getConfig();
  }

  /**
   * 阻止默认拖拽事件
   */
  mounted(): void {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  /**
   * watch
   * 当前的页面情景
   **/
  get scene(): string|undefined {
    if(this.parsed) {
      return this.PARSE;
    }
    if(/^\/edit\/add/.test(this.$route.path)) {
      return this.ADD;
    }
    if(/^\/edit\/modify\//.test(this.$route.path)) {
      return this.MODIFY;
    }
    if(/^\/edit\/copy\//.test(this.$route.path)) {
      return this.COPY;
    }
  }

  /**
   * 通过url获取详情
   * @param url 产品链接
   */
  async getDetailByUrl(url: string): Promise<void> {
    if (!url) {
      this.$message.error('请输入产品链接');
      return;
    }
    await getDetailByUrl(url, true).then(res => {
      if (res.data && res.data.status === 'OK') {
        this.parsed = true;
        this.formData = res.data.result;
        this.initForm();
        this.$message.success('解析成功');
      } else {
        this.$message.error('解析失败');
      }
    }).catch(() => {})
  }

  /**
   * 通过id获取详情
   * @param id itemId
   */
  async getDetailById(id: number): Promise<void> {
    await getDetailById(id, true).then(res => {
      if (res.data && res.data.status === 'OK') {
        this.formData = res.data.result;
        this.initForm();
      }
    }).catch(() => {})
  }

  /**
   * 获取复制item详情
   */
  async copyItem(params: {copyItemId: number, country: string}) {
    await copyItem(params, true).then(res => {
      if (res.data && res.data.status === 'OK') {
        this.formData = res.data.result;
        this.initForm();
      }
    }).catch(() => {})
  }

  /**
   * item数据初始化
   */
  initForm(): void {
    this.formData.mainInfo = this.formData.mainInfo || {};
    this.formData.spus = this.formData.spus || [];
    this.formData.goods = this.formData.goods || [];
    this.formData.covers = this.formData.covers || [];
    this.formData.details = this.formData.details || [];
    this.coverList = this.formData.covers.map((url: string) => ({
      name: '',
      url
    }))
    this.coverShowList = [...this.coverList]
    this.detailShowList = this.detailList =this.formData.details.map((url: string) => ({
      name: '',
      url
    }))
    this.detailShowList = [...this.detailList]
    this.isForward = this.formData.mainInfo.isForward == 1;
    try {
      this.tspuIdList = this.formData.tspuIds? this.formData.tspuIds.split(';') : [];
      if (this.formData.mainInfo.asset) {
        this.asset = JSON.parse(this.formData.mainInfo.asset);
      }
      this.tspuIdList = this.formData.tspuIds? this.formData.tspuIds.split(';') : [];
    } catch (e) {}
  }

  /**
   * 获取字典信息
   */
  getConfig(): void {
    if (!this.$store.state.region || this.$store.state.region.length === 0) {
      getConfig({type: 'region'}).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.countryList = res.data.result || [];
          store.commit('SET_REGION', this.countryList);
        }
      })
    } else {
      this.countryList = this.$store.state.region;
    }
    if (!this.$store.state.language || this.$store.state.language.length === 0) {
      getConfig({type: 'language'}).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.languageList = res.data.result || [];
          store.commit('SET_LANGUAGE', this.languageList);
        }
      })
    } else {
      this.languageList = this.$store.state.language;
    }
  }

  /**
   * 上传item信息
   */
  submit(): void {
    console.log(this.coverList,this.detailList)
    this.formData.covers = this.coverList.map(item => item.url);
    this.formData.details = this.detailList.map(item => item.url);
    if (!this.checkForm()) {
      return;
    }
    saveEditItemDetail(this.formData, true).then(res => {
      if (res.data && res.data.status === 'OK') {
        this.$message.success('保存成功')
        this.$router.push('/edit/list');
      } else {
        this.$message.error(res.data.body.message);
      }
    }).catch(() => {})
  }

  /**
   * 校验表单内容是否通过
   */
  checkForm(): boolean {
    for (let key of Object.keys(this.rules)) {
      if(!validator(this.rules[key], this.formData.mainInfo[key], (msg: string) => {
        this.$message.error(msg);
        this.activeName = 'info';
        setTimeout(() => {
          const element: any = this.$refs[key];
          element.focus();
        }, 0)
      })) {
        return false;
      }
    }
    return true;
  }

  /**
   * 添加spu
   * @param spus spu列表
   */
  addSpu(spus: any[]): void {
    spus.push({id: this.newSpuId++, spuName: '', specs:[{specValue: [{}]}]});
    console.log(spus)
  }

  /**
   * 删除spu
   * @param spus spu列表
   * @param index 删除索引
   */
  deleteSpu(spus: any[], index: number): void  {
    spus.splice(index, 1);
  }

  /**
   * count  扣减数 暂时没有录入的地方  默认与一致
   *
   */
  goodSpuCount(spu: any): void {
    spu.count = 0;
    //spu.count = spu.selectCount;
  }

  /**
   * 添加规格
   * @param specs 规格列表
   */
  addSpec(specs: any[]): void  {
    specs.push({specValue: [{}]});
  }

  /**
   * 删除规格
   * @param specs 规格列表
   * @param index 删除索引
   */
  deleteSpec(specs: any[], index: number): void  {
    specs.splice(index, 1);
  }

  /**
   * 添加规格小项
   * @param specValue 规格小项列表
   */
  addSpecValue(specValue: any[]): void  {
    specValue.push({});
  }

  /**
   * 删除规格小项
   * @param specValue 规格小项列表
   * @param index 删除索引
   */
  deleteSpecValue(specValue: any[], index: number): void  {
    specValue.splice(index, 1);
  }

  /**
   * 隐藏规格小项
   * @param value 规格小项
   */
  hideSpecValue(value: any) {
    value.isHidden = !value.isHidden;
    this.$forceUpdate();
  }

  /**
   * 添加套餐
   * @param goods 套餐列表
   */
  addPackage(goods: any[]): void {
    goods.push({spus:[{}]});
  }

  /**
   * 删除套餐
   * @param goods 套餐列表
   * @param index 删除索引
   */
  deletePackage(goods: any[], index: number): void  {
    goods.splice(index, 1);
  }

  /**
   * 隐藏套餐
   * @param good 套餐
   */
  hidePackage(good: any) {
    good.hidden = !good.hidden;
    this.$forceUpdate();
  }

  /**
   * 添加套餐规格
   * @param spus 套餐规格列表
   */
  addPackageSpu(spus: any[]): void {
    spus.push({});
  }

  /**
   * 删除套餐规格
   * @param spus 套餐规格列表
   * @param index 删除索引
   */
  deletePackageSpu(spus: any[], index: number): void  {
    spus.splice(index, 1);
  }

  /**
   * 改变是否转寄item状态
   */
  changeIsForward(): void {
    this.formData.mainInfo.isForward = this.isForward ? 1 : 0;
  }

  /**
   * 轮播图拖拽排序
   */
  coverSort(): void {
    if (this.coverDraggable) {
      const uploadList = this.coverShowList.filter((item: any) => item.status === 'uploading')
      this.coverShowList = [...this.coverList, ...uploadList];
    }
    this.coverDraggable = !this.coverDraggable;
  }

  /**
   * 详情图拖拽排序
   */
  detailSort(): void {
    if (this.detailDraggable) {
      const uploadList = this.detailShowList.filter((item: any) => item.status === 'uploading')
      this.detailShowList = [...this.detailList, ...uploadList];
    }
    this.detailDraggable = !this.detailDraggable;
  }

  /**
   * 图片删除前确认钩子函数
   */
  beforeRemove(): any {
    return this.$confirm(`确定移除该图片吗？`);
  }

  /**
   * 轮播图删除钩子函数
   */
  handleRemove(file: {name: string, url: string}, list: any): void {
    this.coverList = [...list];
    this.coverShowList = [...list];
  }

  /**
   * 轮播图上传成功钩子函数
   */
  handleSuccess(res: any, file: any, fileList: any): void {
    if (res && res['result'][0]) {
      file.url = res['result'][0];
      // 图片根据上传顺序重新排序
      let front;
      for (let [index, item] of fileList.entries()) {
        if(item.status !== 'success' && !front) {
          front = index;
        }
        if (item.uid === file.uid && front) {
          fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
          break;
        }
        this.coverShowList = fileList;
      }
      this.coverList.push(file);
    }
  }

  /**
   * 详情图删除钩子函数
   */
  handleRemove1(file: {name: string, url: string}, list: any): void {
    this.detailList = [...list];
    this.detailShowList = [...list];
  }

  /**
   * 详情图上传成功钩子函数
   */
  handleSuccess1(res: any,file: any, fileList: any): void {
    if (res && res['result'][0]) {
      file.url = res['result'][0];
      // 图片根据上传顺序重新排序
      let front;
      for (let [index, item] of fileList.entries()) {
        if(item.status !== 'success' && !front) {
          front = index;
        }
        if (item.uid === file.uid && front) {
          fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
          break;
        }
        this.detailShowList = fileList;
      }
      this.detailList.push(file);
    }
  }

  /**
   * 规格上传成功钩子函数
   */
  handleSuccess2(res: any, file: any, fileList: any, value: any): void {
    if (res && res['result'][0]) {
      value.resource = res['result'][0];
    }
    this.$forceUpdate();
  }

  /**
   * 图片上传失败钩子函数
   */
  handleError(e: any): void {
    this.$message.warning('图片上传失败！');
    if(e.status === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录')
      this.$router.replace({
        path: '/login',
        query: {redirect: this.$router.currentRoute.fullPath}
      })
    }
  }

  /**
   * 图片展示
   */
  handlePictureCardPreview(file: {name: string, url: string}): void {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  /**
   * 图片查重
   */
  checkDuplicate(image: {url: string}){
    store.commit('SET_LOADING_MESSAGE', '正在对当前产品查重');
    checkDuplicate({itemId: this.formData.mainInfo.itemId, image: image.url, country: this.formData.mainInfo.country}).then(res => {
      store.commit('SET_LOADING_MESSAGE', '');
      if (res.data.status === 'OK') {
        this.duplicateImages = res.data.result || [];
        if(this.duplicateImages.length === 0) {
          this.$message('该地区未发现人工建品记录')
        } else {
          this.duplicateImagesVisible = true;
        }
      } else {
        this.$message.error(res.data.message)
      }
    }).catch(() => {
      store.commit('SET_LOADING_MESSAGE', '');
    })
  }
  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank')
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

}
